<div class="container-fluid" style="background-color: white;">
    <div class="row justify-content-center">

        <!-- TICKET PANEL -->
        <div class="col-12 mt-2 p-0">
            <mat-expansion-panel class="customPanel ticketPanel" expanded appInViewport>
                <mat-expansion-panel-header class="customPanelHeader yellowBg">
                    <mat-panel-title>
                        <span class="panelTitle">
                            <!-- <i class="bi bi-file-earmark-text me-2"></i> -->
                            {{"TICKET.LIST.TICKET" | translate}}
                        </span>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="row justify-content-center">
                    <div class="col-12" style="position: relative;">
                        <!-- ADD TICKET -->
                        <div class="col-auto" [ngClass]="{'upperPosition': isSmall, 'lowerPosition': !isSmall}"
                            style="position: absolute; z-index: 1000;">
                            <button class="btn btn-outline-dark me-2" (click)="newTicket()">
                                <i class="me-2 bi bi-plus-lg"></i>
                                {{"TICKET.LIST.CREATETICKET" | translate}}
                            </button>
                        </div>
                        <app-ticket-table [ticketList]="ticketList"></app-ticket-table>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </div>
</div>
